import { render, staticRenderFns } from "./Quotation-Table.vue?vue&type=template&id=2ce2e402&scoped=true"
import script from "./Quotation-Table.vue?vue&type=script&lang=js"
export * from "./Quotation-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2e402",
  null
  
)

export default component.exports